<template>
  <div>
    <div class="text-subtitle-2 text-h6 mb-3">
      <span class="font-weight-bold secondary-font">{{ $t("account.title") }}</span>
    </div>
    <v-card class="rounded-md mb-4">
      <v-tabs
        height="55"
        show-arrows
        slider-size="3"
        v-model="tab"
        class="elevation-2 rounded-lg"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          class="font-weight-bold text-body-1"
          :to="{ name: 'account' }"
        >
          <v-icon
            :class="{
              'primary--text': tab === '/account/',
              'black--text': tab !== '/account/',
            }"
            left
            >mdi-account-tie</v-icon
          >
          <span
            :class="{
              'primary--text': tab === '/account/',
              'black--text': tab !== '/account/',
            }"
            class="secondary-font"
            >{{ $t("menu.account.profile") }}</span
          >
        </v-tab>
        <v-tab
          :to="{ name: 'account-api'}"
          class="font-weight-bold text-body-1"
          v-if="$auth.check('ROLE_PARTNER')"
        >
          <v-icon
            :class="{
              'primary--text': tab === '/account/api/',
              'black--text': tab !== '/account/api/',
            }"
            left
            >mdi-cog-outline</v-icon
          >
          <span
            :class="{
              'primary--text': tab === '/account/api/',
              'black--text': tab !== '/account/api/',
            }"
            class="secondary-font"
            >{{ $t("menu.account.api") }}</span
          >
        </v-tab>
        <v-tab
          :to="{ name: 'account-security' }"
          class="font-weight-bold text-body-1"
        >
          <v-icon
            :class="{
              'primary--text': tab === '/account/security/',
              'black--text': tab !== '/account/security/',
            }"
            left
            >mdi-shield-account-outline</v-icon
          >
          <span
            :class="{
              'primary--text': tab === '/account/security/',
              'black--text': tab !== '/account/security/',
            }"
            class="secondary-font"
            >{{ $t("menu.account.security") }}</span
          >
        </v-tab>
      </v-tabs>
    </v-card>
    <v-row>
      <v-col cols="12" sm="5">
        <v-card class="pt-5 pb-2">
          <v-card-text>
            <div
              class="d-flex align-center justify-center flex-column flex-wrap"
            >
              <v-avatar
                color="grey lighten-3"
                size="100"
              >
                <img
                  :src="require('@/assets/img/user.png')"
                  alt="John"
                />
              </v-avatar>
            </div>
            <v-list class="mt-2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <div class="d-flex align-center">
                    <v-list-item-title class="text-body-1 font-weight-bold">
                      <v-icon left>mdi-clock-outline</v-icon>
                      {{ $t("commons.fields.last_update.title") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="ml-auto text-right">
                      <span class="text-body-1">
                        {{
                          $moment(this.$auth.user().updated).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        }}
                      </span>
                    </v-list-item-subtitle>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="7">
        <router-view></router-view>
      </v-col>
    </v-row>
  </div>
</template>


<script>
export default {
  data: () => ({
    tab: null
  })
};
</script>